import Vue from 'vue'
// @ts-ignore
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router/index'
import 'amfe-flexible' // rem 适配

// vant 按需引用
import {
  Toast,
  Popup,
  Button,
  Dialog,
  Field
} from 'vant'
import MessageBoxPlugin from "./components/MessageBoxPlugin"
Vue.use(VueRouter)
    .use(Toast)
    .use(Popup)
    .use(Button)
    .use(Field)
    .use(Dialog)
    .use(MessageBoxPlugin)

Vue.config.productionTip = false

//平台、设备和操作系统 

var system ={ 
  win : false, 
  mac : false, 
  xll : false
};
//检测平台
var p = navigator.platform; 
system.win = p.indexOf("Win") == 0; 
system.mac = p.indexOf("Mac") == 0; 
system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
if(system.win||system.mac||system.xll){   
  alert('禁止使用PC端访问')
}else{
  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app')
}
//test 临时打开
/*new Vue({
	router,
	render: h => h(App),
}).$mount('#app')*/

